// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8038 ? "7ce798d6" : chunkId) + "." + {"6496":"d839d2a14fcaaac6","7297":"cd473341f6597375","8038":"b5e5873f92007610"}[chunkId] + ".js";
};